import type { NskResponse } from "~/models/Api";
import type { DealConstructionScheduleEdit } from "~/models/DealConstructionSchedule";
import { postRequest } from "../api_handler";

const paths = {
	create: "/vendors/deals/:deal_id/deal_construction_schedules"
};

export const create = async (
	dealId: number,
	schedules: DealConstructionScheduleEdit[]
): Promise<NskResponse> =>
	postRequest(paths.create.replace(":deal_id", String(dealId)), {
		dealConstructionSchedules: schedules
	});
